import React from "react";
import { useTranslation } from "react-i18next";

const FormStepsPreview = (props) => {
  let step = props.step;
  const { t } = useTranslation();



  return (
    <div className="steps">
      <div
        className={
          "step " + (step === 1 ? "active" : step > 1 ? "skipped" : null)
        }
      >
        <div className="number">1</div>
        <div className="text-wrapper position-relative">
          <div className="text">{t("fillForm")}</div>
        </div>
      </div>
      <div
        className={
          "step " + (step === 2 ? "active" : step > 1 ? "skipped" : null)
        }
      >
        <div className="number">2</div>
        <div className="text-wrapper position-relative">
          <div className="text">{t("checkStatus")}</div>
        </div>
      </div>
    </div>
  );
};

export default FormStepsPreview;
